import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import type { UnitOfMeasure } from '@ztechapps/common.contract'
import { DataListRow } from './DataListRow'

export const ListRow = (props: BodyRowConfig<UnitOfMeasure>) => {
  return (
    <>
      <RowNumberBodyCell {...props} />
      <DataListRow {...props} />
    </>
  )
}
